import EmblaCarousel from 'embla-carousel'

export default function ({ el }) {
    const emblaNode = el.querySelector('.embla')
    const options = { loop: false }
    const emblaApi = EmblaCarousel(emblaNode, options)
    let current = 0
    const slideTo = (event) => {
        const target = event.target.closest('.thumb')
        const index = [...target.parentElement.children].indexOf(target)

        if (index > current && emblaApi.slideNodes().length - 1 < index) {
            current = 0
        } else if (index < current && index < 0) {
            current = emblaApi.slideNodes().length - 1
        } else {
            current = index
        }

        emblaApi.scrollTo(current)
    }

    const elements = el.querySelectorAll('.thumb')

    elements.forEach((element) => {
        element.addEventListener('click', slideTo)
    })

    const prev = el.querySelector('.nav-prev')
    const next = el.querySelector('.nav-next')

    const hideShowNav = () => {
        if (emblaApi.canScrollPrev()) {
            prev.style.display = 'block'
        } else {
            prev.style.display = 'none'
        }

        if (emblaApi.canScrollNext()) {
            next.style.display = 'block'
        } else {
            next.style.display = 'none'
        }
    }

    if (prev) {
        prev.addEventListener('click', function () {
            emblaApi.scrollPrev()
            hideShowNav()
        })
    }

    if (next) {
        next.addEventListener('click', function () {
            emblaApi.scrollNext()
            hideShowNav()
        })
    }

    if (prev && next) {
        hideShowNav()
        emblaApi.on('scroll', hideShowNav)
    }
}
